import { SVGProps } from 'react';

export type SVGRProps = {
  title?: string;
  titleId?: string;
};

const SvgInterfaceclose = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    aria-labelledby={titleId}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="m12.05 10.972 5.895-5.878L19 6.146l-5.895 5.877 5.849 5.83-1.055 1.053-5.848-5.83L6.103 19l-1.055-1.054 5.946-5.922L5 6.053 6.055 5l5.995 5.972Z"
      fill={props.color}
    />
  </svg>
);

export default SvgInterfaceclose;
